import { Button, Form, Input, type InputRef } from 'antd';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
interface Props {
  initialTitle?: string;
  template: 'word' | 'excel' | 'powerpoint';
  onSubmit: (name: string) => void;
  onCancel: () => void;
}

export const FileFromTemplateForm = ({ initialTitle, template, onSubmit, onCancel }: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const inputRef = useRef<InputRef>(null);
  /**
   * Handles the submission of form data, processes and transforms it into a `User` object,
   * and passes the constructed user object to the given submission handler.
   *
   * @param {any} values - The form values submitted by the user. Includes fields such as
   * firstName, lastName, email, role, expirationDate, and privateUser.
   */
  const handleFinish = (values: any) => {
    onSubmit(values.title);
  };

  useEffect(() => {
    if (initialTitle) {
      form.setFieldsValue({
        title: initialTitle,
      });
    } else {
      switch (template) {
        case 'word':
          form.setFieldsValue({
            title: t('common.wordDocument'),
          });
          break;
        case 'excel':
          form.setFieldsValue({
            title: t('common.excelDocument'),
          });
          break;
        case 'powerpoint':
          form.setFieldsValue({
            title: t('common.pptDocument'),
          });
          break;
        default:
          form.setFieldsValue({
            title: t('common.untitledDocument'),
          });
      }
    }

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }, 200);
  }, [initialTitle, form]);

  return (
    <Form
      layout="vertical"
      form={form}
      size="large"
      className="pt-6 [&_.ant-form-item-explain-error]:hidden [&_.ant-form-item-label]:hidden [&_.ant-form-item]:mb-2"
      onFinish={handleFinish}
    >
      <Form.Item
        name="title"
        normalize={(v: string) => v.replace(/\s{3,}/g, ' ').trimStart()}
        rules={[
          {
            required: true,
            message: t('Please enter a name'),
            transform: (value: string) => value?.trim(),
          },
        ]}
      >
        <Input ref={inputRef} autoFocus autoCapitalize="none" placeholder="Title" maxLength={255} />
      </Form.Item>
      <div className="mt-4 flex flex-row items-center justify-end gap-2">
        <Button size="middle" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
        <Button size="middle" type="primary" htmlType="submit">
          {t('common.save')}
        </Button>
      </div>
    </Form>
  );
};

export default FileFromTemplateForm;
